import React, {FC, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import * as fonts from '../../../../../util/fonts';
import LocationPin from '../../../../../assets/medical-network-location.png';
import colors from '../../../../../util/colors';
import {strings} from '../../../../../util/strings';
import AppButton from '../../../../../components/app-button';
import moment from 'moment';
import {formatPhone} from '../../../../../util/utility';
import {post} from '../../../../../api/api';
import {uriPostCountClicks} from '../../../../../api/endpoints';
import ClinicMap from './ClinicMap';

interface LatLngInterface {
  index?: number;
  lat: number;
  lng: number;
}

interface ClinicsInfoProps {
  name: any;
  phone: any;
  email: any;
  url: any;
  address: any;
  clinic?: any;
  showPrice?: boolean;
  goToClinicDetail?(value: any): void;
  buStyles: any;
  labels: typeof strings.pt.rede;
  selectedBu: any;
  precoEstimadoFuncAtiva: boolean;
  hideMap?: boolean;
}

const ClinicsInfo: FC<ClinicsInfoProps> = ({
  name,
  phone,
  email,
  url,
  address,
  clinic,
  goToClinicDetail,
  buStyles,
  showPrice,
  precoEstimadoFuncAtiva,
  labels,
  hideMap,
  selectedBu,
}) => {
  const [infoBoxPosition, setInfoBoxPosition] = useState<LatLngInterface>({
    lat: clinic.latitude,
    lng: clinic.longitude,
  });

  const featureName = 'MedicalNetwork-ScheduleAppointment';

  const handleChangeInfoBoxPosition = (position: any) => {
    setInfoBoxPosition(position);
  };

  const sendClickInfoHandler = async (action: any) => {
    try {
      const body = {
        buId: selectedBu.buId,
        provider: name,
        action: action,
        feature: 'Rede Médica - Prestador',
      };
      await post(
        uriPostCountClicks(),
        JSON.stringify(body),
        false,
        featureName
      );
    } catch {}
  };

  const handleOnScheduleAppointmentClick = () => {
    sendClickInfoHandler('Marcar Consulta');
    if (phone) {
      window.location.href = `tel:${phone}`;
    } else if (email) {
      window.location.href = `mailto: ${email}`;
    }
  };

  const handleOnEmailClick = () => {
    sendClickInfoHandler('Email');
  };

  const handleOnPhoneClick = () => {
    sendClickInfoHandler('Telefone');
  };

  const clinics = useMemo(() => [clinic], [clinic]);

  return (
    <div className="medic-clinic-container">
      <div className="medic-clinic-info-wrapper">
        <p className="medic-title" style={{...fonts.XL, color: colors.black}}>
          {name}
        </p>
        {goToClinicDetail && (
          <div
            className="app-header-bu-logo-opacity item-title"
            style={{
              ...fonts.M,
              ...fonts.SemiBold,
              color: buStyles.primaryColor,
            }}
            onClick={() => goToClinicDetail(clinic)}>
            {clinic.name}
          </div>
        )}

        {phone && (
          <p style={{...fonts.SM, color: colors.black}}>
            {labels?.medicalNetwork_clinics_telephone}
            {
              <a
                onClick={() => handleOnPhoneClick()}
                href={`tel:${phone}`}
                style={{color: buStyles.primaryColor}}>
                {' '}
                {formatPhone(phone)}
              </a>
            }
          </p>
        )}
        {email && (
          <p style={{...fonts.SM, color: colors.black}}>
            {labels?.medicalNetwork_clinics_email}
            {
              <a onClick={() => handleOnEmailClick()} href={`mailto: ${email}`}>
                {email}
              </a>
            }
          </p>
        )}
        {url && (
          <p style={{...fonts.SM, color: colors.black}}>
            {labels?.medicalNetwork_clinics_website} {url}
          </p>
        )}
        {address && (
          <div className="medic-clinic-address">
            <img src={LocationPin} width="15px" height="17px" />
            <p>
              {address && (
                <>
                  {address}
                  <br></br>
                </>
              )}
            </p>
          </div>
        )}
        {(email || phone) && (
          <AppButton
            onClick={() => {
              handleOnScheduleAppointmentClick();
            }}
            className={
              clinic
                ? 'schedule-appointment-button-caroussel'
                : 'schedule-appointment-button'
            }
            style={{...fonts.Regular}}>
            {labels?.medicalNetwork_schedule_appointment_button}
          </AppButton>
        )}
      </div>
      {!hideMap && (
        <div className="medic-clinic-info-wrapper">
          <ClinicMap
            multipleClinics={false}
            buStyles={buStyles}
            precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
            infoBoxPosition={infoBoxPosition}
            handleChangeInfoBoxPosition={handleChangeInfoBoxPosition}
            clinics={clinics}
            showPrice={showPrice}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({globalStyles, strings, selectedBu}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.rede,
  selectedBu: selectedBu.value,
});

export default compose(connect(mapStateToProps)(ClinicsInfo));
